export const login = '/login';
// There used to be some routes in-place of this comment before the Cognito->Auth0 migration. But since all authentication related activities are done on Auth0, it has been removed.
export const home = '/'; // convenience const to take us to the default home
export const pricing = '/pricing-helper';
export const rep = '/my-agi-rep';
export const landing = home;
export const warrantyclaims = '/warranty-claims';
export const warrantyreg = process.env.REACT_APP_WARRANTY;
export const additionalResources =
  'https://agidealersupport.zendesk.com/hc/en-us';
export const promotions =
  'https://agidealersupport.zendesk.com/hc/en-us/categories/360003127613-Promotions';
// export const priceLists =
//   'https://agidealersupport.zendesk.com/hc/en-us/categories/360004476193-Price-Lists-and-Product-Catalogs';
export const newDealerOnboarding =
  'https://agidealersupport.zendesk.com/hc/en-us/categories/1500000156282-New-Dealer-Onboarding';
export const manuals = '/manuals';
export const configuration = '/configuration';
export const announcement = '/announcement';
export const brochures = '/brochures';
export const logos = '/logos';
export const priceLists = '/priceLists';
export const monthlyPrize = '/monthly-prize-promotion';
export const augerCalculator = '/auger-calculator';
// footer links pages
export const terms = '/terms';
export const contact = '/contact';
